// extracted by mini-css-extract-plugin
export default {"heading":"GU","container":"HU","product_section_row":"IU","carousel":"JU","carouselwide":"KU","carouselwrapper":"LU","blockwrapper":"MU","product_carousel_row":"NU","headingnarrow":"OU","title":"PU"};
    if(module.hot) {
      // 1738836197875
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  